export default function MinusIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
        <path d="M12 5.7875H0V7.2125H12V5.7875Z"/>
    </svg>
  );
}
